/**
 * CL-CLIENT-UX-001 / CL-TRADES-SUPPLIER-COLLAB-001B-R4 — Client portal module permission keys.
 * Dependency-free so capability resolvers can import without circular imports.
 */

export const CLIENT_PORTAL_MODULE_PERMISSION_KEYS = Object.freeze({
  schedule: "canViewSchedule",
  construction: "canViewConstruction",
  financials: "canViewFinancials",
  resources: "canViewResources",
  messages: "canViewMessages",
  suppliers: "canViewSuppliersAndSelections",
});

export const CLIENT_PORTAL_MODULE_PERMISSION_KEY_LIST = Object.freeze(
  Object.values(CLIENT_PORTAL_MODULE_PERMISSION_KEYS)
);

export function isClientPortalModulePermissionKey(key = "") {
  return CLIENT_PORTAL_MODULE_PERMISSION_KEY_LIST.includes(String(key ?? "").trim());
}

export function pickExplicitClientPortalModulePermissionBooleans(source = {}) {
  const flags = {};
  CLIENT_PORTAL_MODULE_PERMISSION_KEY_LIST.forEach((key) => {
    if (typeof source?.[key] === "boolean") {
      flags[key] = source[key];
    }
  });
  return flags;
}

/**
 * Persist explicit client-module booleans only. Grants require strict boolean true.
 */
export function normalizeClientPortalModulePermissionsForAssignmentSave(
  permissions = {},
  { rawPermissions = null } = {}
) {
  const source = rawPermissions && typeof rawPermissions === "object" ? rawPermissions : permissions;
  const next = { ...(permissions || {}) };
  CLIENT_PORTAL_MODULE_PERMISSION_KEY_LIST.forEach((key) => {
    if (typeof source?.[key] === "boolean") {
      next[key] = source[key] === true;
      return;
    }
    delete next[key];
  });
  return next;
}
